import { Box, Typography } from '@mui/material';

import { runSummaryAgentReportStyles } from './styles/runSummaryAgentReportStyles';

export default function OutcomeBar({ completed = 0, failed = 0, total = 0 }) {
  const completedPercent = total ? Math.round((completed / total) * 1000) / 10 : 0;
  const failedPercent = total ? Math.round((failed / total) * 1000) / 10 : 0;
  const emptyPercent = Math.max(0, 100 - completedPercent - failedPercent);

  return (
    <Box sx={runSummaryAgentReportStyles.drilldownOutcomeCell}>
      <Box sx={runSummaryAgentReportStyles.drilldownOutcomeBar}>
        <Box
          sx={runSummaryAgentReportStyles.drilldownOutcomeSegment(completedPercent, 'success.main')}
        />
        <Box
          sx={runSummaryAgentReportStyles.drilldownOutcomeSegment(failedPercent, 'error.main')}
        />
        <Box
          sx={runSummaryAgentReportStyles.drilldownOutcomeSegment(
            emptyPercent,
            'custom.surfaceAlt',
          )}
        />
      </Box>
      <Typography variant="caption" color="text.secondary">
        {completedPercent}% / {failedPercent}%
      </Typography>
    </Box>
  );
}
